<template>
    <v-container>
        <v-row>
            <v-col
                    cols="12"
            >
                <h1 class="font-weight-bold display-1 text-center ">Search - {{ term }} - {{ msg }}</h1>
                <hr>
                <v-row>
                    <v-col
                            cols="6"
                            lg="3"
                            md="3"
                            sm="6"
                            xs="6"
                            v-for="(product,index) in products"
                            :key="index"

                    >
                        <v-card
                                class="mx-auto"
                                :hover="true"
                                :to="'/'+product.meta_url"
                        >

                            <!--no images-->
                            <v-img
                                    v-if="!(product.images) && $vuetify.breakpoint.smAndUp"
                                    class="white--text align-end"
                                    height="400"
                                    max-height="420"
                                    min-height="170"
                                    :src="cdnUrl+'/products/no-img.jpg'"
                                    gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                            >
                                <v-card-title>{{ product.name }}</v-card-title>
                            </v-img>
                            <v-img
                                    v-else-if="!(product.images) && $vuetify.breakpoint.xsOnly"
                                    class="white--text align-end"
                                    height="210"
                                    max-height="420"
                                    min-height="170"
                                    :src="cdnUrl+'/products/no-img.jpg'"
                                    gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                            >
                                <v-card-title>{{ product.name }}</v-card-title>
                            </v-img>
                            <!--images-->
                            <v-img
                                    v-else-if="product.images && product.in_stock && $vuetify.breakpoint.smAndUp"
                                    class="white--text align-end"
                                    height="400"
                                    max-height="420"
                                    min-height="170"
                                    :src="cdnUrl+'/products/'+product.images[0].src"
                                    gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                            >
                                <v-card-title>{{ product.name }}</v-card-title>
                            </v-img>
                            <v-img
                                    v-else-if="product.images && product.in_stock == 0 && $vuetify.breakpoint.smAndUp"
                                    class="white--text align-end"
                                    height="400"
                                    max-height="420"
                                    min-height="170"
                                    :src="cdnUrl+'/products/'+product.images[0].src"
                                    gradient="to bottom, rgba(0,0,0,.5), rgba(0,0,0,.8)"
                            >
                                <v-card-title>{{ product.name }}</v-card-title>
                            </v-img>
                            <v-img
                                    v-else-if="product.images && product.in_stock && $vuetify.breakpoint.xsOnly"
                                    class="white--text align-end"
                                    height="210"
                                    max-height="420"
                                    min-height="170"
                                    :src="cdnUrl+'/products/'+product.images[0].src"
                                    gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                            >
                                <v-card-title>{{ product.name }}</v-card-title>
                            </v-img>
                            <v-img
                                    v-else-if="product.images && product.in_stock == 0 && $vuetify.breakpoint.xsOnly"
                                    class="white--text align-end"
                                    height="210"
                                    max-height="420"
                                    min-height="170"
                                    :src="cdnUrl+'/products/'+product.images[0].src"
                                    gradient="to bottom, rgba(0,0,0,.5), rgba(0,0,0,.8)"
                            >
                                <v-card-title >{{ product.name }}</v-card-title>
                            </v-img>
                            <v-card-text class="text--primary d-none d-lg-flex" style="height: 100px">
                                <div style="overflow: auto" v-html="product.short_description"></div>
                            </v-card-text>
                            <v-card-actions >
                                <v-btn
                                        v-if="product.consulta == 0"
                                        class="title"
                                        color="green"
                                        text

                                >
                                    <span v-if="product.type == 'simple' ">${{ product.regular_price | number_format_real }}</span>
                                    <span v-else-if="product.range_price.min == product.range_price.max">${{ product.range_price.min | number_format_real }}</span>
                                    <span v-else>${{ product.range_price.min | number_format_real }} / ${{ product.range_price.max | number_format_real }}</span>
                                </v-btn>
                                <v-btn
                                        v-else
                                        color="red"
                                        style="color: #0d47a1;"
                                        text
                                        outlined
                                >
                                    On request
                                </v-btn>
                                <v-btn
                                        v-if="product.in_stock"
                                        color="orange"
                                        icon
                                        class="display-4"
                                        x-large
                                >
                                    <v-icon>mdi-cart</v-icon>
                                </v-btn>
                                <v-btn
                                        v-else-if="$vuetify.breakpoint.xsOnly"
                                        color="red"
                                        style="color: #0d47a1;"
                                        icon
                                >

                                    <v-img src="../assets/img/not_avaliable.png" width="40px" ></v-img>
                                </v-btn>
                                <v-btn
                                        v-else
                                        color="red"
                                        style="color: #0d47a1;"
                                        text
                                        outlined
                                >
                                    NOT AVALIABLE
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
    export default {
        props: {
            cartVisible: { type: Boolean },
            appUrl: { type: String },
            cdnUrl: { type: String },
        },
        metaInfo () {
            return {
                title: 'PPS Healthcare – Search',
                meta: [
                    {description: 'PPS Healthcare – Search'},
                    {keywords: 'PPS Healthcare – Search'}
                ]
            }
        },
        data () {
            return {
                term:"",
                products:"",
                msg:""
            }
        },
        methods: {
            init() {
                var newTerm = window.location.search.slice(1).replace('g=','');
                if(newTerm != this.term){
                    this.term = decodeURI(newTerm);
                    var arr = {
                        search:this.term,
                    };
                    arr = JSON.stringify(arr);
                    this.$http.post(this.appUrl+"/store/search",arr).then(response => {
                        if(response.data.erro){
                            this.msg = "No products found."
                        }else{
                            this.products = response.data.data;
                            this.msg = response.data.msg[0];
                        }
                    });
                }
            }
        },
        mounted(){
            this.$emit('showCart');
            var self = this;
            setInterval(function(){
                    self.init();
                }, 500
            );
        },
        filters:{
            number_format_real(valor){
                return String(parseFloat(valor).toFixed(2));
            },
        }
    }
</script>